import React from "react";
import {Nav, Tab, Card} from "react-bootstrap";
import { Container, Row, Col } from "react-bootstrap";
import ValkyrieLogo from '../../Assets/Valkyrie_ES_Logo.png'
import ShuChibi from '../../Assets/Image/(Uncompromisable_Outfit)_Shu_Itsuki_Chibi.webp'
import ShuSound from '../../Assets/Sound/vo_shu_bm_combo_3.mp3'
import ClickMeAnimation from "../Fun/ChibiButton";
import ShuHead from '../../Assets/Image/shu_head.png'

function FanworksCard() {
  return (
    <Card className="box-card">
    <Tab.Container  id="fanworks-page" defaultActiveKey="Fics">
          <Nav variant="pills" fill className="navi-custom">
            <Nav.Item>
              <Nav.Link eventKey="Fics">My Fics</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="Art">My Art</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="Gifted">Gifted</Nav.Link>
            </Nav.Item>
          </Nav>
    <Tab.Content>
            <Tab.Pane eventKey="Fics">
      <Card.Body>
        <div className="fic">
        <p><strong>Fics I've written:</strong></p>
          <ul className="bulletsCustom">
            <li><a href="https://archiveofourown.org/works/20028526" target="_blank">excuses (NatsuHokke prompt)</a></li>
          </ul>
        </div>
      </Card.Body>
      </Tab.Pane>
    </Tab.Content>

    <Tab.Content>
    <Tab.Pane eventKey="Art">
      <Card.Body>
      <div className="fanworks">
      <div className="fic">
        <p><strong>Art I've drawn:</strong></p>
          <ul className="bulletsCustom">
            <li>Something will go here when I'm confident in my art again...</li>
          </ul>
        </div>
        </div>
      </Card.Body>
      </Tab.Pane>
    </Tab.Content>
    <Tab.Content>
    <Tab.Pane eventKey="Gifted">
      <Card.Body>
      <div className="fanworks">
          <p><strong>Artwork I've commissioned or been gifted:</strong></p>
          <ul className="bulletsCustom">
            <li><a href="https://twitter.com/appendorange/status/1238426656194408448?s=20&t=YJ4HNtISErnMPtszsv0z5w" target="_blank">NatsuHokke Commission by @appendorange</a></li>
          </ul>     
        </div>
      </Card.Body>
      </Tab.Pane>
    </Tab.Content>
    </Tab.Container>
    <div className="profileFooter">
        <Row>
        <Col xs={4}>
        <img className="logo" src={ValkyrieLogo}/>
        </Col>
        <Col xs={8}>
        <ClickMeAnimation head={ShuHead} img={ShuChibi} sound={ShuSound}/>
        </Col>
        </Row>
    </div>
    </Card>
  );
}

export default FanworksCard;

